import { render } from "./ControlCardHeader.vue?vue&type=template&id=840f8d58"
import script from "./ControlCardHeader.vue?vue&type=script&lang=js"
export * from "./ControlCardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__